// import React, { useState, useEffect, useMemo } from "react";
// import {
//   Box,
//   Card,
//   Typography,
//   TextField,
//   Button,
//   Chip,
//   Avatar,
//   Stack,
//   Alert,
//   CircularProgress,
//   Paper,
//   Grid,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TablePagination,
//   InputAdornment,
// } from "@mui/material";
// import { toast } from "react-toastify";
// import { useSelector } from "react-redux";
// import {
//   postApiCallVenueAssignByAdmin,
//   postGetVenueOwnerList,
// } from "../../../../Core/Apicall";
// import PersonAddIcon from "@mui/icons-material/PersonAdd";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import SearchIcon from "@mui/icons-material/Search";
// import CommonPagination from "../../../Common/CommonPagination/CommonPagination";

// interface VenueOwner {
//   _id: string;
//   userId: string;
//   fullName?: string;
//   firstName?: string;
//   lastName?: string;
//   emailId?: string;
//   phoneNumber?: any;
//   phoneCountryCode?: any;
//   profileImagePath?: string;
//   isActive?: boolean;
//   role?: number;
//   approvalStatus?: string;
//   isAssignedToVenue?: boolean;
//   assignedVenueId?: string | null;
//   hasVenueAssigned?: boolean;
//   createdAt?: string;
//   name?: string; // Added for display
// }

// interface AssignVenueOwnerProps {
//   venueId: string;
//   venueName: string;
// }

// const AssignVenueOwner: React.FC<AssignVenueOwnerProps> = ({ venueId, venueName }) => {

//   const [venueOwners, setVenueOwners] = useState<VenueOwner[]>([]);
//   const [loading, setLoading] = useState<boolean>(false);
//   const [assignLoading, setAssignLoading] = useState<boolean>(false);
//   const [assigningId, setAssigningId] = useState<string | null>(null); // Track which owner is being assigned
//   const [search, setSearch] = useState<string>("");
//   const [page, setPage] = useState<number>(0);
//   const [rowsPerPage, setRowsPerPage] = useState<number>(10);
//   const [totalCount, setTotalCount] = useState<number>(0);
//   const isProfileData = useSelector((state: any) => state?.global?.profileData);
//   const totalPages = Math.ceil(totalCount / rowsPerPage);

//   const fetchVenueOwners = async () => {
//     setLoading(true);
//     try {
//       const response = await postGetVenueOwnerList({
//         userId: isProfileData?.userId,
//         role: 5,
//         search: search,
//         offset: page + 1,
//         limit: rowsPerPage,
//         venueId: venueId,
//       });
//       setVenueOwners(response?.data);
//       setTotalCount(response.totalCount || 0);
//     } catch (error) {
//       console.error("Error fetching venue owners:", error);
//       toast.error("Failed to fetch venue owners");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchVenueOwners();
//   }, [page, rowsPerPage, search, venueId]);

//   // Handle assign owner
//   const handleAssignOwner = async (owner: VenueOwner) => {
//     console.log("owner", owner);

//     if (!owner.userId) {
//       toast.error("Invalid owner selected");
//       return;
//     }

//     setAssignLoading(true);
//     setAssigningId(owner.userId);

//     try {
//       const response = await postApiCallVenueAssignByAdmin({
//         venueId: venueId,
//         userId: owner.userId,
//       });

//       console.log("response",response);
      

//       if (response?.success) {
//         toast.success(response.message || `Venue assigned to ${owner.name} successfully!`);
//         setVenueOwners(prev =>
//           prev.map(o => ({
//             ...o,
//             isAssignedToVenue: o.userId === owner.userId,
//           }))
//         );
//         fetchVenueOwners();
//       } else {
//         toast.error(response?.message || "Failed to assign venue owner");
//       }
//     } catch (error: any) {
//       console.error("Error assigning owner:", error);
//       toast.error(error?.message || "Failed to assign venue owner");
//     } finally {
//       setAssignLoading(false);
//       setAssigningId(null);
//     }
//   };

//   // Handle search
//   const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     setSearch(e.target.value);
//     setPage(0);
//   };

//   return (
//     <Box sx={{ p: 2 }}>
//       <Paper elevation={0} sx={{ p: 3, borderRadius: 2, border: "1px solid #e0e0e0" }}>
//         {/* Header */}
//         <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3, flexWrap: "wrap", gap: 2 }}>
//           <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//             <Typography variant="h6" sx={{ fontWeight: 600 }}>
//               Venue Owners
//             </Typography>
//             <Chip
//               label={`${totalCount} owners`}
//               size="small"
//               variant="outlined"
//             />
//           </Box>

//           {/* Search */}
//           <TextField
//             size="small"
//             placeholder="Search owners..."
//             value={search}
//             onChange={handleSearchChange}
//             sx={{ width: 280 }}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <SearchIcon fontSize="small" sx={{ color: "text.secondary" }} />
//                 </InputAdornment>
//               ),
//             }}
//           />
//         </Box>

//         {/* Loading State */}
//         {loading ? (
//           <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
//             <CircularProgress />
//           </Box>
//         ) : (
//           <>
//             <TableContainer>
//               <Table>
//                 <TableHead>
//                   <TableRow sx={{ bgcolor: "#f8f9fa" }}>
//                     <TableCell sx={{ fontWeight: 600 }}>Owner</TableCell>
//                     <TableCell sx={{ fontWeight: 600 }}>Email</TableCell>
//                     <TableCell sx={{ fontWeight: 600 }}>Phone</TableCell>
//                     <TableCell sx={{ fontWeight: 600 }}>Document</TableCell>
//                     <TableCell sx={{ fontWeight: 600, textAlign: "center" }}>Action</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {venueOwners.length > 0 ? (
//                     venueOwners.map((owner) => {
//                       const isThisOwnerAssigning = assigningId === owner.userId;

//                       return (
//                         <TableRow
//                           key={owner.userId}
//                           sx={{
//                             bgcolor: owner.isAssignedToVenue ? "#e8f5e9" : "transparent",
//                             "&:hover": {
//                               bgcolor: owner.isAssignedToVenue ? "#c8e6c9" : "#f5f5f5",
//                             },
//                             transition: "background-color 0.2s ease",
//                           }}
//                         >
//                           <TableCell>
//                             <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                               <Avatar
//                                 src={owner.profileImagePath}
//                                 sx={{ width: 40, height: 40 }}
//                               >
//                                 {/* 🔥 FIX: Show first letter of name */}
//                                 {owner.name?.charAt(0)?.toUpperCase() || "U"}
//                               </Avatar>
//                               <Box>
//                                 {/* 🔥 FIX: Show name */}
//                                 <Typography variant="body2" sx={{ fontWeight: 500 }}>
//                                   {owner.name}
//                                 </Typography>
//                                 {owner.isAssignedToVenue && (
//                                   <Chip
//                                     label="Assigned"
//                                     color="success"
//                                     size="small"
//                                     icon={<CheckCircleIcon sx={{ fontSize: 12 }} />}
//                                     sx={{ mt: 0.5, height: 20, fontSize: "0.65rem" }}
//                                   />
//                                 )}
//                               </Box>
//                             </Box>
//                           </TableCell>
//                           <TableCell>{owner.emailId || "-"}</TableCell>
//                           <TableCell>
//                             {owner.phoneCountryCode} {owner.phoneNumber || "-"}
//                           </TableCell>
//                           <TableCell>
//                             {owner.approvalStatus ? (
//                               <Chip
//                                 label={owner.approvalStatus}
//                                 color={
//                                   owner.approvalStatus === "Approved"
//                                     ? "success"
//                                     : owner.approvalStatus === "Pending"
//                                       ? "warning"
//                                       : "default"
//                                 }
//                                 size="small"
//                               />
//                             ) : (
//                               <Typography variant="caption" color="text.secondary">
//                                 Not Uploaded
//                               </Typography>
//                             )}
//                           </TableCell>
//                           <TableCell sx={{ textAlign: "center" }}>
//                             {owner.isAssignedToVenue ? (
//                               <Button
//                                 variant="outlined"
//                                 color="success"
//                                 size="small"
//                                 disabled
//                                 startIcon={<CheckCircleIcon />}
//                                 sx={{ minWidth: "100px" }}
//                               >
//                                 Assigned
//                               </Button>
//                             ) : (
//                               <Button
//                                 variant="contained"
//                                 size="small"
//                                 onClick={() => handleAssignOwner(owner)}
//                                 disabled={assignLoading}
//                                 sx={{
//                                   backgroundColor: "black",
//                                   "&:hover": { backgroundColor: "#333" },
//                                   "&:disabled": {
//                                     backgroundColor: "#999",
//                                     cursor: "not-allowed",
//                                   },
//                                   minWidth: "100px",
//                                 }}
//                                 startIcon={isThisOwnerAssigning ? <CircularProgress size={16} color="inherit" /> : <PersonAddIcon />}
//                               >
//                                 {isThisOwnerAssigning ? "Assigning..." : "Assign"}
//                               </Button>
//                             )}
//                           </TableCell>
//                         </TableRow>
//                       );
//                     })
//                   ) : (
//                     <TableRow>
//                       <TableCell colSpan={5} sx={{ textAlign: "center", py: 4 }}>
//                         <Alert severity="info" sx={{ borderRadius: 2 }}>
//                           No venue owners found. Please add venue owners first.
//                         </Alert>
//                       </TableCell>
//                     </TableRow>
//                   )}
//                 </TableBody>
//               </Table>
//             </TableContainer>

//             <CommonPagination
//               page={page}
//               rowsPerPage={rowsPerPage}
//               totalItems={totalCount}
//               totalPages={totalPages}
//               onPageChange={(value: number) => setPage(value)}
//               onRowsPerPageChange={(value: number) => {
//                 setRowsPerPage(value);
//                 setPage(1);
//               }}
//             />
//           </>
//         )}
//       </Paper>
//     </Box>
//   );
// };

// export default AssignVenueOwner;


import React, { useState, useEffect, useMemo } from "react";
import {
  Box,
  Card,
  Typography,
  TextField,
  Button,
  Chip,
  Avatar,
  Stack,
  Alert,
  CircularProgress,
  Paper,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import {
  postApiCallVenueAssignByAdmin,
  postGetVenueOwnerList,
  postApiCallVenueUnassignByAdmin, // New API call for unassign
} from "../../../../Core/Apicall";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SearchIcon from "@mui/icons-material/Search";
import CommonPagination from "../../../Common/CommonPagination/CommonPagination";

interface VenueOwner {
  _id: string;
  userId: string;
  fullName?: string;
  firstName?: string;
  lastName?: string;
  emailId?: string;
  phoneNumber?: any;
  phoneCountryCode?: any;
  profileImagePath?: string;
  isActive?: boolean;
  role?: number;
  approvalStatus?: string;
  isAssignedToVenue?: boolean;
  assignedVenueId?: string | null;
  hasVenueAssigned?: boolean;
  createdAt?: string;
  name?: string; // Added for display
}

interface AssignVenueOwnerProps {
  venueId: string;
  venueName: string;
}

const AssignVenueOwner: React.FC<AssignVenueOwnerProps> = ({ venueId, venueName }) => {

  const [venueOwners, setVenueOwners] = useState<VenueOwner[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [assignLoading, setAssignLoading] = useState<boolean>(false);
  const [assigningId, setAssigningId] = useState<string | null>(null); // Track which owner is being assigned
  const [unassigningId, setUnassigningId] = useState<string | null>(null); // Track which owner is being unassigned
  const [search, setSearch] = useState<string>("");
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);
  
  // Unassign confirmation dialog
  const [unassignDialogOpen, setUnassignDialogOpen] = useState<boolean>(false);
  const [selectedOwnerForUnassign, setSelectedOwnerForUnassign] = useState<VenueOwner | null>(null);
  
  const isProfileData = useSelector((state: any) => state?.global?.profileData);
  const totalPages = Math.ceil(totalCount / rowsPerPage);

  const fetchVenueOwners = async () => {
    setLoading(true);
    try {
      const response = await postGetVenueOwnerList({
        userId: isProfileData?.userId,
        role: 5,
        search: search,
        offset: page + 1,
        limit: rowsPerPage,
        venueId: venueId,
      });
      setVenueOwners(response?.data);
      setTotalCount(response.totalCount || 0);
    } catch (error) {
      console.error("Error fetching venue owners:", error);
      toast.error("Failed to fetch venue owners");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVenueOwners();
  }, [page, rowsPerPage, search, venueId]);

  // Handle assign owner
  const handleAssignOwner = async (owner: VenueOwner) => {
    console.log("owner", owner);

    if (!owner.userId) {
      toast.error("Invalid owner selected");
      return;
    }

    setAssignLoading(true);
    setAssigningId(owner.userId);

    try {
      const response = await postApiCallVenueAssignByAdmin({
        venueId: venueId,
        userId: owner.userId,
      });

      console.log("response", response);
      

      if (response?.success) {
        toast.success(response.message || `Venue assigned to ${owner.name} successfully!`);
        setVenueOwners(prev =>
          prev.map(o => ({
            ...o,
            isAssignedToVenue: o.userId === owner.userId,
          }))
        );
        fetchVenueOwners();
      } else {
        toast.error(response?.message || "Failed to assign venue owner");
      }
    } catch (error: any) {
      console.error("Error assigning owner:", error);
      toast.error(error?.message || "Failed to assign venue owner");
    } finally {
      setAssignLoading(false);
      setAssigningId(null);
    }
  };

  // Handle unassign owner - Open confirmation dialog
  const handleOpenUnassignDialog = (owner: VenueOwner) => {
    setSelectedOwnerForUnassign(owner);
    setUnassignDialogOpen(true);
  };

  // Handle unassign owner - Confirm
  const handleConfirmUnassign = async () => {
    if (!selectedOwnerForUnassign) {
      toast.error("No owner selected for unassignment");
      return;
    }

    setUnassigningId(selectedOwnerForUnassign.userId);
    setUnassignDialogOpen(false);

    try {
      const response = await postApiCallVenueUnassignByAdmin({
        venueId: venueId,
        userId: selectedOwnerForUnassign.userId,
      });

      console.log("Unassign response:", response);

      if (response?.success) {
        toast.success(response.message || `Venue unassigned from ${selectedOwnerForUnassign.name} successfully!`);
        setVenueOwners(prev =>
          prev.map(o => ({
            ...o,
            isAssignedToVenue: o.userId === selectedOwnerForUnassign.userId ? false : o.isAssignedToVenue,
          }))
        );
        fetchVenueOwners();
      } else {
        toast.error(response?.message || "Failed to unassign venue owner");
      }
    } catch (error: any) {
      console.error("Error unassigning owner:", error);
      toast.error(error?.message || "Failed to unassign venue owner");
    } finally {
      setUnassigningId(null);
      setSelectedOwnerForUnassign(null);
    }
  };

  // Handle search
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
    setPage(0);
  };

  return (
    <Box sx={{ p: 2 }}>
      <Paper elevation={0} sx={{ p: 3, borderRadius: 2, border: "1px solid #e0e0e0" }}>
        {/* Header */}
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3, flexWrap: "wrap", gap: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Venue Owners
            </Typography>
            <Chip
              label={`${totalCount} owners`}
              size="small"
              variant="outlined"
            />
          </Box>

          {/* Search */}
          <TextField
            size="small"
            placeholder="Search owners..."
            value={search}
            onChange={handleSearchChange}
            sx={{ width: 280 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" sx={{ color: "text.secondary" }} />
                </InputAdornment>
              ),
            }}
          />
        </Box>

        {/* Loading State */}
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow sx={{ bgcolor: "#f8f9fa" }}>
                    <TableCell sx={{ fontWeight: 600 }}>Owner</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Email</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Phone</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Document</TableCell>
                    <TableCell sx={{ fontWeight: 600, textAlign: "center" }}>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {venueOwners.length > 0 ? (
                    venueOwners.map((owner) => {
                      const isThisOwnerAssigning = assigningId === owner.userId;
                      const isThisOwnerUnassigning = unassigningId === owner.userId;

                      return (
                        <TableRow
                          key={owner.userId}
                          sx={{
                            bgcolor: owner.isAssignedToVenue ? "#e8f5e9" : "transparent",
                            "&:hover": {
                              bgcolor: owner.isAssignedToVenue ? "#c8e6c9" : "#f5f5f5",
                            },
                            transition: "background-color 0.2s ease",
                          }}
                        >
                          <TableCell>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                              <Avatar
                                src={owner.profileImagePath}
                                sx={{ width: 40, height: 40 }}
                              >
                                {owner.name?.charAt(0)?.toUpperCase() || "U"}
                              </Avatar>
                              <Box>
                                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                  {owner.name}
                                </Typography>
                                {owner.isAssignedToVenue && (
                                  <Chip
                                    label="Assigned"
                                    color="success"
                                    size="small"
                                    icon={<CheckCircleIcon sx={{ fontSize: 12 }} />}
                                    sx={{ mt: 0.5, height: 20, fontSize: "0.65rem" }}
                                  />
                                )}
                              </Box>
                            </Box>
                          </TableCell>
                          <TableCell>{owner.emailId || "-"}</TableCell>
                          <TableCell>
                            {owner.phoneCountryCode} {owner.phoneNumber || "-"}
                          </TableCell>
                          <TableCell>
                            {owner?.isAssignedToVenue && owner.approvalStatus ? (
                              <Chip
                                label={owner.approvalStatus}
                                color={
                                  owner.approvalStatus === "Approved"
                                    ? "success"
                                    : owner.approvalStatus === "Pending"
                                      ? "warning"
                                      : owner.approvalStatus === "Rejected"
                                        ? "error"
                                        : "default"
                                }
                                size="small"
                              />
                            ) : (
                              <Typography variant="caption" color="text.secondary">
                                {!owner?.isAssignedToVenue ? "":"Not Uploaded"}
                              </Typography>
                            )}
                          </TableCell>
                          <TableCell sx={{ textAlign: "center" }}>
                            {owner.isAssignedToVenue ? (
                              <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
                                {/* Assigned Button - Disabled */}
                                <Button
                                  variant="outlined"
                                  color="success"
                                  size="small"
                                  disabled
                                  startIcon={<CheckCircleIcon />}
                                  sx={{ minWidth: "100px" }}
                                >
                                  Assigned
                                </Button>
                                
                                {/* Unassign Button */}
                                <Button
                                  variant="outlined"
                                  color="error"
                                  size="small"
                                  onClick={() => handleOpenUnassignDialog(owner)}
                                  disabled={isThisOwnerUnassigning}
                                  startIcon={isThisOwnerUnassigning ? <CircularProgress size={16} color="inherit" /> : <PersonRemoveIcon />}
                                  sx={{
                                    minWidth: "90px",
                                    borderColor: "#d32f2f",
                                    color: "#d32f2f",
                                    "&:hover": {
                                      borderColor: "#b71c1c",
                                      backgroundColor: "rgba(211, 47, 47, 0.04)",
                                    },
                                    "&:disabled": {
                                      borderColor: "#ccc",
                                      color: "#ccc",
                                    },
                                  }}
                                >
                                  {isThisOwnerUnassigning ? "Removing..." : "Unassign"}
                                </Button>
                              </Box>
                            ) : (
                              <Button
                                variant="contained"
                                size="small"
                                onClick={() => handleAssignOwner(owner)}
                                disabled={assignLoading}
                                sx={{
                                  backgroundColor: "black",
                                  "&:hover": { backgroundColor: "#333" },
                                  "&:disabled": {
                                    backgroundColor: "#999",
                                    cursor: "not-allowed",
                                  },
                                  minWidth: "100px",
                                }}
                                startIcon={isThisOwnerAssigning ? <CircularProgress size={16} color="inherit" /> : <PersonAddIcon />}
                              >
                                {isThisOwnerAssigning ? "Assigning..." : "Assign"}
                              </Button>
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableRow>
                      <TableCell colSpan={5} sx={{ textAlign: "center", py: 4 }}>
                        <Alert severity="info" sx={{ borderRadius: 2 }}>
                          No venue owners found. Please add venue owners first.
                        </Alert>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <CommonPagination
              page={page}
              rowsPerPage={rowsPerPage}
              totalItems={totalCount}
              totalPages={totalPages}
              onPageChange={(value: number) => setPage(value)}
              onRowsPerPageChange={(value: number) => {
                setRowsPerPage(value);
                setPage(1);
              }}
            />
          </>
        )}
      </Paper>

      {/* 🔥 Unassign Confirmation Dialog */}
      <Dialog
        open={unassignDialogOpen}
        onClose={() => setUnassignDialogOpen(false)}
        aria-labelledby="unassign-dialog-title"
        aria-describedby="unassign-dialog-description"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="unassign-dialog-title" sx={{ fontWeight: 600 }}>
          Unassign Venue Owner
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="unassign-dialog-description" sx={{ mb: 2 }}>
            Are you sure you want to unassign <strong>{selectedOwnerForUnassign?.name}</strong> from 
            <strong> "{venueName}"</strong>?
          </DialogContentText>
          <Alert severity="warning" sx={{ borderRadius: 2 }}>
            This action will remove the owner's access to this venue. 
            {selectedOwnerForUnassign?.approvalStatus === "Pending" && 
              " Their document approval request will also be cancelled."}
          </Alert>
          <Box sx={{ mt: 2, p: 2, bgcolor: "#f5f5f5", borderRadius: 2 }}>
            <Typography variant="caption" color="text.secondary" display="block">
              <strong>Owner:</strong> {selectedOwnerForUnassign?.name}
            </Typography>
            <Typography variant="caption" color="text.secondary" display="block">
              <strong>Email:</strong> {selectedOwnerForUnassign?.emailId}
            </Typography>
            <Typography variant="caption" color="text.secondary" display="block">
              <strong>Document Status:</strong> {selectedOwnerForUnassign?.approvalStatus || "Not Uploaded"}
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button
            onClick={() => setUnassignDialogOpen(false)}
            disabled={!!unassigningId}
            sx={{ color: "#666" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmUnassign}
            variant="contained"
            color="error"
            disabled={!!unassigningId}
            sx={{
              fontWeight: 500,
              "&:hover": {
                backgroundColor: "#b71c1c",
              },
            }}
            startIcon={unassigningId ? <CircularProgress size={16} color="inherit" /> : <PersonRemoveIcon />}
          >
            {unassigningId ? "Unassigning..." : "Yes, Unassign"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AssignVenueOwner;